// achivements section
document.addEventListener("DOMContentLoaded", () => {
    const selector = document.querySelector('.doctor-achievements');

    if(selector) {
        const tabItems = selector.querySelectorAll('.doctor-achievements__nav__item');
        const tabContent = selector.querySelectorAll('.doctor-achievements__block__content');

        function resetClasses() {
            tabItems.forEach( (item) => {
                item.classList.remove('active');
            });
            tabContent.forEach((content) => {
                content.classList.remove('active');
            });
        }
        
        tabItems.forEach( (item) => {
            let targetID = item.getAttribute('data-id');
            item.addEventListener('click', (e)=> {
                e.preventDefault();
                
                resetClasses();
                
                e.target.classList.add('active');
                selector.querySelector('.doctor-achievements__block__content[data-block-id="'+targetID+'"]').classList.add('active');
            });
        });

    }
});